/** See `src/i18n/locales/en/audit.ts`. */
export const audit = {
  page: {
    title: 'Journal d’audit',
    scopedLead:
      'Vous voyez les actions autorisées pour vos propres entreprises ; les réponses de consentement et les liens d’identité ne sont jamais inclus.',
    actionFilter: 'Filtrer par action',
    actionPlaceholder: 'action, p. ex. department.visibility.update',
    scopeFilter: 'Filtrer par portée',
    scopePlaceholder: 'id de portée',
    filter: 'Filtrer',
    empty: 'Aucune ligne d’audit.',
    when: 'Quand',
    action: 'Action',
    actorRole: 'Rôle de l’auteur',
    target: 'Cible',
    rowsLabel: 'les lignes d’audit',
  },
} as const;
